export const primary = {
  main: '#638BD9'
};

export const secondary = {
  main: '#606C78'
};

export const warning = {
  main: '#ff9800'
};
export const danger = {
  main: '#f44336'
};

export const green = '#47B972';

export const text = {
  primary: '#202528',
  secondary: '#606C78',
  muted: '#A5ACB4'
};

export const divider = '#E2E7EA';

// Status palette shared across the CCA wizard (review steps + success
// summary) and any future status pills/badges in the app.
export const status = {
  success: { background: '#E8F6EF', foreground: '#1E7E50', border: '#D5EBDD' },
  warning: { background: '#FFF3E0', foreground: '#E65100', border: '#F5E3BD' },
  warningStrong: { background: '#FFF6E5', foreground: '#9A6300' },
  failure: { background: '#FDECEC', foreground: '#B3261E', border: '#F7D2D0' },
  info: { background: '#EEF2FB', foreground: primary.main },
  highlight: { background: '#F1F5FF' },
  neutral: { background: '#F0F1F4', foreground: '#606C78' },
  surface: { muted: '#F7F8FA' }
};
